import React from 'react';
import { videos } from '../shared/assets';
import '../BrandHomePage/GlacierVideoSection/GlacierVideoSection.css';

/**
 * AtacamaVideoSection - Full viewport video section
 * Features:
 * - Full viewport height video background
 * - Atacama brand video (atacamabrand3.mp4)
 * - Uses same styling as brand homepage glacier video
 */
export const AtacamaVideoSection: React.FC = () => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  
  // Use the Atacama video
  const videoSrc = videos.atacamaHeaderVideo || "/videos/atacamabrand3.mp4";
  
  React.useEffect(() => {
    // Ensure video plays
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.error('Atacama video autoplay failed:', err);
      });
    }
  }, [videoSrc]);
  
  return (
    <section className="glacier-video-section">
      <div className="glacier-video-section__container">
        <video
          ref={videoRef}
          src={videoSrc}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="glacier-video-section__video"
          onLoadedData={() => console.log('Atacama video loaded:', videoSrc)}
          onError={(e) => console.error('Atacama video error:', e, videoSrc)}
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  );
};

export default AtacamaVideoSection;